import React, { useCallback, useContext, useEffect, useState } from 'react';
import { GlobalContext } from '../../context/GlobalState';
import UserStatusBar from './UserStatusBar';
import { getUsersById } from '../../services/users';
import { setUserDoneStatus } from '../../services/retrospectives';
import { logEvent, TrackingEvents } from '../../tracking';

const UserStatusBarContainer = ({ retrospective }) => {
  const { user } = useContext(GlobalContext);
  const [currentUserDone, setCurrentUserDone] = useState(
    retrospective.usersDoneWithCurrentStage.includes(user.id)
  );
  const [usersDone, setUsersDone] = useState(
    retrospective.usersDoneWithCurrentStage
  );
  const [membersBar, setMembersBar] = useState([
    ...new Set([retrospective.facilitator, ...retrospective.participants]),
  ]);
  const [popupMembers, setPopupMembers] = useState([]);

  const loadUserData = useCallback(async () => {
    const users = [...retrospective.participants];
    if (!users.includes(retrospective.facilitator)) {
      users.push(retrospective.facilitator);
    }
    const participantsData = await getUsersById(users);
    const participantsStatus = participantsData.map((pD) => ({
      ...pD,
      done: retrospective.usersDoneWithCurrentStage.includes(pD.id),
    }));

    const userIndex = participantsStatus.findIndex((u) => u.id === user.id);
    const [currentUserData] = participantsStatus.splice(userIndex, 1);
    participantsStatus.unshift(currentUserData);

    setCurrentUserDone(currentUserData.done);

    const members = [...participantsStatus];
    const hiddenMembers = members.splice(24, members.length - 25);
    setMembersBar(members);
    setPopupMembers(hiddenMembers);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [retrospective]);

  useEffect(() => {
    loadUserData();
  }, [loadUserData]);

  useEffect(() => {
    if (
      usersDone.toString() !==
      retrospective.usersDoneWithCurrentStage.toString()
    ) {
      setUsersDone(retrospective.usersDoneWithCurrentStage);
      loadUserData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    retrospective.usersDoneWithCurrentStage,
    retrospective.stage,
    loadUserData,
  ]);

  useEffect(() => {
    if (retrospective.usersDoneWithCurrentStage.length === 0) {
      setCurrentUserDone(false);
    }
  }, [retrospective.stage, retrospective.usersDoneWithCurrentStage.length]);

  const handleCurrentUserDone = useCallback(() => {
    logEvent(TrackingEvents.CLICK_IM_FINISHED, { finished: !currentUserDone });
    setUserDoneStatus(
      retrospective.id,
      usersDone.includes(user.id) ? 'remove' : 'add',
      user.id
    );
  }, [currentUserDone, retrospective.id, user.id, usersDone]);

  if (membersBar.length <= 0) {
    return null;
  }

  return (
    <UserStatusBar
      currentUserDone={currentUserDone}
      membersBar={membersBar}
      popupMembers={popupMembers}
      handleCurrentUserDone={handleCurrentUserDone}
    />
  );
};

export default UserStatusBarContainer;
